module.exports = __webpack_public_path__ + "img/robyn-smith.2cfc7e4e.png";